@if (isError | async) {
  <div class="error">
    <div class="error-container">
      <img
        class="error-image"
        [src]="'../../../../assets/imgs/404/' + getTheme() + '.png'"
        alt=""
      />
      <h2 class="error-text">Page not found</h2>
      <button class="error-button" (click)="back()">Back</button>
    </div>
  </div>
}
